<template>
  <div ref="roomList" class="meetingBook">
    <div class="subHead">
      <van-icon name="arrow-left" class="arrow" @click="goBack" />
      <span class="subHead-text">{{ subHead }}</span>
    </div>
    <div class="header">
      <van-search
        v-model="searchData.search"
        placeholder="请输入搜索关键词"
        class="van-field__control"
        @input="onSearch"
      />
    </div>
    <div style="display: flex; justify-content: center">
      <div class="search">
        <div style="padding: 0 20px">
          <svg-icon icon-class="picker-arrow-l" class="icon" @click="onLast" />
        </div>
        <div class="date" @click="show = true">{{ searchData.date }}</div>
        <div style="padding: 0 20px">
          <svg-icon icon-class="picker-arrow-r" class="icon" @click="onNext" />
        </div>
      </div>
    </div>
    <van-list
      v-model="loading"
      :offset="300"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="item in meetingRoom" :key="item.id" class="room">
        <div class="header">
          <div>{{ item.name }}</div>
          <van-button type="info" size="small" @click="() => onBook(item.id, item.name)">预约</van-button>
        </div>
        <div class="content">
          <div class="time">可用时间 {{ item.openTime }}-{{ item.closedTime }}</div>
          <div v-if="item.approve" class="info1">需要审批</div>
          <div v-else class="info2">不需审批</div>
        </div>
        <div class="footer">
          <div class="clock">
            <div class="pie" v-html="item.amHtml" />
            <ul class="min" v-html="minHtml" />
            <ul class="hour" v-html="hourHtml" />
            <ul class="numbers">
              <li style="right: 0.3333rem; top: 0.2233rem">1</li>
              <li style="right: 0.1283rem; top: 0.395rem">2</li>
              <li style="right: 0.0433rem; top: 0.71rem">3</li>
              <li style="right: 0.1183rem; top: 1.01rem">4</li>
              <li style="right: 0.3233rem; top: 1.21rem">5</li>
              <li style="left: 0.765rem; top: 1.2997rem">6</li>
              <li style="left: 0.48rem; top: 1.2117rem">7</li>
              <li style="left: 0.2533rem; top: 1.01rem">8</li>
              <li style="left: 0.1633rem; top: 0.71rem">9</li>
              <li style="left: 0.2483rem; top: 0.395rem">10</li>
              <li style="left: 0.46rem; top: 0.2233rem">11</li>
              <li style="left: 0.765rem; top: 0.145rem">0</li>
            </ul>
            <ul class="pointer" />
            <div class="circle">
              <div class="circle_in">
                AM
              </div>
            </div>
          </div>
          <div class="clock">
            <div class="pie" v-html="item.pmHtml" />
            <ul class="min" v-html="minHtml" />
            <ul class="hour" v-html="hourHtml" />
            <ul class="numbers">
              <li style="right: 0.3833rem; top: 0.2433rem">13</li>
              <li style="right: 0.1783rem; top: 0.395rem">14</li>
              <li style="right: 0.0933rem; top: 0.71rem">15</li>
              <li style="right: 0.17583rem; top: 1.01rem">16</li>
              <li style="right: 0.35rem; top: 1.21rem">17</li>
              <li style="left: 0.730rem; top: 1.2997rem">18</li>
              <li style="left: 0.45rem; top: 1.2117rem">19</li>
              <li style="left: 0.2533rem; top: 1.01rem">20</li>
              <li style="left: 0.1633rem; top: 0.71rem">21</li>
              <li style="left: 0.2583rem; top: 0.395rem">22</li>
              <li style="left: 0.45rem; top: 0.2433rem">23</li>
              <li style="left: 0.730rem; top: 0.15rem">12</li>
            </ul>
            <ul class="pointer" />
            <div class="circle">
              <div class="circle_in">
                PM
              </div>
            </div>
          </div>
        </div>
      </div>
    </van-list>
    <van-calendar v-model="show" :default-date="currentDate" @confirm="onConfirm" />
  </div>
</template>

<script>
import { roomList } from '@/api/user';
import { Search, Calendar } from 'vant';
import moment from 'moment';
export default {
  name: 'MeetingBook',
  components: {
    [Search.name]: Search,
    [Calendar.name]: Calendar
  },
  filters: {
    getScaleTime(val, item) {
      if (val % 4 === 0) {
        const start = item.openTime.split(':');
        if (start[0].startsWith('0')) {
          return `${Number(start[0].charAt(1)) + (val / 2)}:${start[1]}`;
        } else {
          return `${Number(start[0]) + (val / 2)}:${start[1]}`;
        }
      } else {
        return '';
      }
    }
  },
  data() {
    return {
      searchData: {
        search: '',
        page: 1,
        size: 10,
        date: moment().format('YYYY-MM-DD')
      },
      total: 0,
      meetingRoom: [],
      currentDate: new Date(),
      subHead: '会议预约',
      show: false,
      loading: false,
      scroll: 0,
      maxPage: 0,
      finished: false,
      amHtml: '',
      pmHtml: '',
      hourHtml: '',
      minHtml: ''
    };
  },
  computed: {
    remakeDate() {
      this.searchData.date = this.$store.state.meetingDate;
      return this.$store.state.meetingDate;
    }
  },
  watch: {
    remakeDate() {}
  },
  mounted() {
    this.createHourLines();
    this.createMinLines();
  },
  activated() {
    this.getList();
    this.$refs.roomList.scrollTop = this.scroll;
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // vm.$destroy();
      if (from.name === 'user') {
        vm.scroll = 0;
        vm.total = 0;
        vm.meetingRoom = [];
        vm.currentDate = new Date();
        vm.searchData = {
          search: '',
          page: 1,
          size: 10,
          date: moment().format('YYYY-MM-DD')
        };
        vm.getList();
      }
      // if (from.name === 'roomInfo') {
      //   vm.$store.dispatch('clearSubmitForm');
      // }
    });
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'user' });
      this.$store.dispatch('setDate', { data: moment().format('YYYY-MM-DD') });
    },
    getList(load) {
      // load 判断是否为下拉刷新
      this.loading = true;
      this.searchData.page = load ? this.searchData.page : 1;
      roomList(this.searchData).then(res => {
        const list = res.data.list;
        this.total = res.data.total;
        this.maxPage = Math.ceil(res.data.totals / this.searchData.size);
        this.finished = this.searchData.page > this.maxPage;
        list.forEach(item => {
          const data = this.changeTime([{
            startTime: item.openTime,
            endTime: item.closedTime
          }]);
          if (item.meetings) {
            item.meetings.forEach(son => {
              son.startTime = son.startTime.slice(-8, -3);
              son.endTime = son.endTime.slice(-8, -3);
            });
          }
          item.occupy = this.changeTime(item.meetings);
          const { amHtml, pmHtml } = this.createPie(item.occupy);
          item.amHtml = amHtml;
          item.pmHtml = pmHtml;
          if (data.length > 0) {
            item.width = 100 / (data.length - 1);
          }
          const effectiveTimeNum = [];
          data.forEach(son => {
            if (item.occupy.includes(son)) {
              const val = {
                show: true,
                value: son
              };
              effectiveTimeNum.push(val);
            } else {
              const val = {
                show: false,
                value: son
              };
              effectiveTimeNum.push(val);
            }
          });
          item.effectiveTimeNum = effectiveTimeNum;
        });
        if (load) {
          this.meetingRoom.push(...list);
        } else {
          this.meetingRoom = list;
        }
        this.loading = false;
      });
      this.loading = false;
    },
    changeTime(arr) {
      const list = [];
      arr.forEach(item => {
        const start = item.startTime.split(':');
        var roomStartHour = '';
        if (start[0].startsWith('0')) {
          roomStartHour = start[0].charAt(1) * 6 + Number(start[1].charAt(0));
        } else {
          roomStartHour = start[0] * 6 + Number(start[1].charAt(0));
        }
        const end = item.endTime.split(':');
        var roomEndHour = '';
        if (end[0].startsWith('0')) {
          roomEndHour = end[0].charAt(1) * 6 + Number(end[1].charAt(0));
        } else {
          roomEndHour = end[0] * 6 + Number(end[1].charAt(0));
        }
        for (let i = roomStartHour; i < roomEndHour; i++) {
          list.push(i);
        }
      });
      return list;
    },
    onSearch() {
      this.getList();
    },
    onCancel() {},
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    onConfirm(date) {
      this.show = false;
      this.searchData.date = this.formatDate(date);
      this.getList();
      this.$store.dispatch('setDate', { data: this.searchData.date });
    },
    onBook(id, name) {
      this.scroll = this.$refs.roomList.scrollTop;
      this.$router.push({ name: 'roomInfo', query: { id, name }});
    },
    onLast() {
      if (this.searchData.date !== moment().format('YYYY-MM-DD')) {
        this.searchData.date = moment(this.searchData.date).subtract(1, 'days').format('YYYY-MM-DD');
        this.currentDate = new Date(this.searchData.date);
        this.getList();
        this.$store.dispatch('setDate', { data: this.searchData.date });
      }
    },
    onNext() {
      this.searchData.date = moment(this.searchData.date).add(1, 'days').format('YYYY-MM-DD');
      this.currentDate = new Date(this.searchData.date);
      this.getList();
      this.$store.dispatch('setDate', { data: this.searchData.date });
    },
    onLoad() {
      if (this.searchData.page > this.maxPage) {
        return;
      } else {
        ++this.searchData.page;
      }
      this.getList(true);
    },
    createHourLines() {
      /* 绘制钟表的时钟刻度线 */
      let html = '';
      // key1表示x方向上的偏移量，key2表示y方向上的偏移量
      let val, key1, key2;
      for (let i = 0; i < 12; i++) {
        val = i * 30;
        key1 = 0.67;
        key2 = 0;
        if (val > 180 && val < 360) {
          key1 = 0.68;
        }
        if (val > 0 && val < 180) {
          key1 = 0.673;
        }

        if (val > 90 && val < 270) {
          key2 = 0.01;
        }
        if (val < 90 || val > 270) {
          key2 = -0.01;
        }
        html += "<li style='transform: rotate(" + val + 'deg) translate(' + key1 + 'rem, ' + key2 + "rem)'></li>";
      }
      this.hourHtml = html;
    },
    createMinLines() {
      /* 绘制钟表的分钟刻度线 */
      let html = '';
      // key1表示x方向上的偏移量，key2表示y方向上的偏移量 108
      let val, key1, key2;
      for (let i = 0; i < 72; i++) {
        val = i * 5;
        key1 = 0.705;
        key2 = 0;
        if (val > 180 && val < 360) {
          key1 = 0.708;
        }
        if (val > 0 && val < 180) {
          key1 = 0.70;
        }
        if (val > 90 && val < 270) {
          key2 = 0.01;
        }
        if (val < 90 || val > 270) {
          key2 = -0.01;
        }
        html += "<li style='transform: rotate(" + val + 'deg) translate(' + key1 + 'rem, ' + key2 + "rem)'></li>";
      }
      this.minHtml = html;
    },
    createPie(occupy) {
      let amHtml = '';
      for (let i = 0; i < 72; i++) {
        if (occupy.includes(i)) {
          amHtml += "<div style='transform: rotate(" + 5 * i + "deg)skewX(84deg);background: #F2B230'></div>";
        } else {
          amHtml += "<div style='transform: rotate(" + 5 * i + "deg)skewX(84deg);'></div>";
        }
      }
      // this.amHtml = amHtml;

      let pmHtml = '';
      for (let i = 72; i < 144; i++) {
        if (occupy.includes(i)) {
          pmHtml += "<div style='transform: rotate(" + 5 * i + "deg)skewX(84deg);background: #F2B230'></div>";
        } else {
          pmHtml += "<div style='transform: rotate(" + 5 * i + "deg)skewX(84deg);'></div>";
        }
      }
      // this.pmHtml = pmHtml;
      return { amHtml, pmHtml };
    }
  }
};
</script>

<style lang="less">
.meetingBook {
  width: 100%;
  height: calc(100vh);
  overflow-x: hidden;
  box-sizing: border-box;
  padding-bottom: 0.1rem;
  .header {
    .van-field__control {
      text-align: left;
    }
  }
  .search {
    display: flex;
    align-items: center;
    align-items: center;
    margin-top: 0.12rem;
    .date {
      font-size: 0.20rem;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 0.25rem;
      color: #3B86FF;
    }
  }
  .room {
    background: #FFFFFF;
    border: 1px solid #EFEFF4;
    box-shadow: 0px 3px 6px rgba(51, 51, 51, 0.1);
    opacity: 1;
    border-radius: 6px;
    margin: 0.09rem 0.14rem 0rem 0.14rem;
    padding: 0.11rem 0.13rem;
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.15rem;
      font-weight: 400;
      line-height: 0.25rem;
      color: #43425D;
    }
    .content {
      display: flex;
      align-items: center;
      margin-top: 0.01rem;
      .time {
        padding: 0.04rem 0.05rem;
        border: 1px solid #D7DAE2;
        opacity: 1;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.14rem;
        color: rgba(51, 51, 51, 0.7);
        border-radius: 5px;
        opacity: 1;
      }
      .info1 {
        padding: 0.04rem 0.05rem;
        border: 1px solid #F2B230;
        opacity: 1;
        border-radius: 5px;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.14rem;
        color: #F2B230;
        margin-left: 0.02rem;
      }
      .info2 {
        padding: 0.04rem 0.05rem;
        border: 1px solid #50C44F;
        opacity: 1;
        border-radius: 5px;
        font-size: 0.12rem;
        font-weight: 400;
        line-height: 0.14rem;
        color: #52C41A;
        margin-left: 0.02rem;
      }
    }
    .footer {
      margin-top: 0.03rem;
      display: flex;

      .clock {
        width: 1.5rem;
        height: 1.5rem;
        margin: 0.1rem auto;
        border-radius: 50%;
        background-color: #FFFFFF;
        position: relative;
        border: 1px solid #3B86FF;
        display: flex;
        justify-content: center;
        align-items: center;

        .pie {
          width: 100%;
          height: 100%;
          border-radius:50%;
          overflow:hidden;
          position:relative;
          //margin:5em auto;
          transform: rotate(-90deg);

          div {
            width: 100%;
            height: 100%;
            transform-origin:left top;
            position:absolute;
            //left:100px;
            //top:100px;
            top: 50%;
            left: 50%;
            box-sizing:border-box;
            //background: red;
          }
        }

        .circle {
          position: absolute;
          //top: 50%;
          //left: 50%;
          background: white;
          width: 0.25rem;
          height: 0.25rem;
          border-radius: 50%;
          //margin-top: -16px;
          //margin-left: -16px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid #3B86FF;

          .circle_in {
            width: 80%;
            height: 80%;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-color: #3B86FF;
            border: 1px solid #3B86FF;
            color: #FFFFFF;
            font-size: 0.9em;
          }
        }

        .hour li {
          position: absolute;
          width: 0.08rem;
          height: 0.02rem;
          left: 50%;
          top: 50%;
          background-color: #3B86FF;
          transform-origin: left center;
        }

        .min li {
          position: absolute;
          width: 0.05rem;
          height: 0.02rem;
          left: 50%;
          top: 50%;
          background-color: #3B86FF;
          transform-origin: left center;
        }

        .numbers li {
          position: absolute;
          height: 10px;
          width: 10px;
          transform: translate(-50%, -50%);
          font-family: 'Microsoft Yahei';
          font-size: 12px;
          color: #3B86FF;
        }
      }
    }
  }
}
</style>
